import { render, staticRenderFns } from "./ModalPeerAssignee.vue?vue&type=template&id=784f83f0&scoped=true&"
import script from "./ModalPeerAssignee.vue?vue&type=script&lang=js&"
export * from "./ModalPeerAssignee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784f83f0",
  null
  
)

export default component.exports